<!-- company name -->
<div class="col-sm-4" *ngIf="tsCompany.editingMode !== 'edition'">
    <input auto-complete [(ngModel)]="inputTsCompany" [source]="searchCompanies.bind(this)"
           value-property-name="id" [list-formatter]="companyListFormatter"
           [accept-user-input]="false" [placeholder]="'session-details.student-tab.companyPlaceholder' | translate"
           [min-chars]="1" display-property-name="name" id="company"
           class="form-control input-sm" (valueChanged)="changeCompany($event)" autocomplete="off"
           name="company" #companyInput="ngModel" required>

</div>
<div class="col-sm-1" *ngIf="tsCompany.editingMode !== 'edition'">
    <button class="btn btn-default btn-sm" style="margin-bottom: 3px;" aria-hidden="true"
            (click)="showModalAddCompany(addCompanyModal)">
        <i class="fa fa-plus" aria-hidden="true"></i>
    </button>
</div>
<!-- company name -->
<div class="col-sm-5" style="padding-left: 0" *ngIf="tsCompany.editingMode === 'edition'">
    <input [(ngModel)]="tsCompany.selected" disabled="disabled"
           [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
           aria-label="checkbox-trainer">

    <span class="company-name">{{tsCompany.name}}</span>
</div>

<div class="col-sm-5">
    <div class="row">
        <div class="col-sm-6">
            <label>
                <input type="radio" name="priceChoice" id="forfait" value="FORFAIT" [(ngModel)]="tsCompany.billingMode"
                       (change)="onChangeType(tsCompany.billingMode)" class="form-check-input">
                Prix forfaitaire
            </label>
        </div>
        <div class="col-sm-6">
            <label>
                <input type="radio" name="priceChoice" id="byStudent" value="BYSTUDENT"
                       [(ngModel)]="tsCompany.billingMode"
                       (change)="onChangeType(tsCompany.billingMode)" class="form-check-input">
                Prix par stagiaire
            </label>
        </div>
    </div>
</div>

<div class="col-sm-2 price-input">
    <input placeholder="Montant" type="text" class="form-control input-sm" id="price"
           [ngModel]="priceNoCents | commaDot"
           (ngModelChange)="priceNoCents=$event">
    {{displayedCurrency}}
    <div ngbDropdown class="d-inline-block">
        <button class="btn-default" id="dropdownTotal" ngbDropdownToggle>
            <i class="fa fa-fw fa-caret-down"></i></button>
        <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownTotal">
            <li><a class="dropdown-item" (click)="changeCurrency('EURO')">€</a></li>
            <li><a class="dropdown-item" (click)="changeCurrency('DOLLAR')">$</a></li>
        </ul>
    </div>
</div>

<ng-template #addCompanyModal>
    <div class="window-close" (click)="closeCreateCompanyModal()"><i class="fa fa-window-close" aria-hidden="true"></i>
    </div>
    <company-detail (getCompany)="getCreatedCompany($event)" [company]="createdCompany"
                    type="createInModal"></company-detail>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/company-edition/company-edition.component.html